import { GetStaticProps } from 'next'
import { ReactElement } from 'react'

import { dehydrate, QueryClient } from 'react-query'

import { helpCenterConfig } from 'app/services/Query/help-center/help-center.query'
import { NextPage } from 'app/types/decalarations/next'
import { HELP_CENTER_CATEGORY_PARAMS } from 'app/utils/constants/help-center.constants'

import HelpCenterLayout from '~/components/layouts/HelpCenterLayout'
import MainLayout from '~/components/layouts/MainLayout'
import HelpCenterMainView from '~/views/HelpCenter/HelpCenterMainView'

const HelpCenterMainPage: NextPage = () => <HelpCenterMainView />

HelpCenterMainPage.getLayout = (page: ReactElement) => (
  <MainLayout>
    <HelpCenterLayout>{page}</HelpCenterLayout>
  </MainLayout>
)

HelpCenterMainPage.getMeta = (intl) => ({
  title: intl.formatMessage({
    defaultMessage: 'Help Centre'
  }),
  description: intl.formatMessage({
    defaultMessage: 'Pit Stop for Assistance'
  })
})

export const getStaticProps: GetStaticProps = async () => {
  try {
    const queryClient = new QueryClient()
    const { getHelpCenterCategories } = helpCenterConfig

    await queryClient.prefetchQuery(
      getHelpCenterCategories.key(HELP_CENTER_CATEGORY_PARAMS),
      getHelpCenterCategories.request
    )

    return {
      props: { dehydratedState: dehydrate(queryClient) }
    }
  } catch (error) {
    return { notFound: true }
  }
}

export default HelpCenterMainPage
